import useHistoryTableFilterStore, {
	HistoryTableFilterStore,
} from 'src/stores/historyTableFilterStore/useHistoryTableFilterStore';
import { SelectOption } from 'src/components/primitives/Select/hooks/types';
import useSelect from 'src/components/primitives/Select/hooks/useSelect';
import Select from 'src/components/primitives/Select/Select';
import PortfolioHistoryTableControls from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryTableControls';
import PortfolioHistoryTableMarketFilter from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryTableMarketFilter';

const DIRECTION_FILTER_OPTIONS: SelectOption<
	HistoryTableFilterStore['funding-payments']['direction']
>[] = [
	{ label: 'All', value: 'all' },
	{ label: 'Long', value: 'long' },
	{ label: 'Short', value: 'short' },
];

export default function PortfolioHistoryFundingTableControls() {
	const marketFilter = useHistoryTableFilterStore(
		(s) => s.getFilterState('funding-payments')['marketSymbol']
	);
	const directionFilter = useHistoryTableFilterStore(
		(s) => s.getFilterState('funding-payments')['direction']
	);
	const setHistoryTableFilterState = useHistoryTableFilterStore((s) => s.set);

	const handleMarketFilterChange = (selectedMarket: string) => {
		setHistoryTableFilterState((s) => {
			s['funding-payments'].marketSymbol = selectedMarket;
			s['funding-payments'].currentUiPage = 0;
		});
	};

	const handleDirectionFilterChange = (
		selectedType: HistoryTableFilterStore['funding-payments']['direction']
	) => {
		setHistoryTableFilterState((s) => {
			s['funding-payments'].direction = selectedType;
			s['funding-payments'].currentUiPage = 0;
		});
	};

	const {
		open,
		onOpenChange,
		value,
		onValueChange,
		selectOptions,
		selectedOption,
	} = useSelect({
		selectedValue: directionFilter,
		onSelectedValueChange: handleDirectionFilterChange,
		options: DIRECTION_FILTER_OPTIONS,
	});

	return (
		<PortfolioHistoryTableControls
			historyType="funding-payments"
			exportType="funding-payments"
		>
			<PortfolioHistoryTableMarketFilter
				marketType="perp"
				marketFilter={marketFilter}
				handleMarketFilterChange={handleMarketFilterChange}
				id="portfolio-history-funding-table-market-filter"
			/>
			<Select.Root
				open={open}
				onOpenChange={onOpenChange}
				value={value}
				onValueChange={onValueChange}
			>
				<Select.Trigger label="Direction" className="min-w-38">
					{selectedOption?.label}
				</Select.Trigger>
				<Select.Options>
					{selectOptions.map((option) => (
						<Select.Option key={option.value} value={option.value}>
							{option.label}
						</Select.Option>
					))}
				</Select.Options>
			</Select.Root>
		</PortfolioHistoryTableControls>
	);
}
